import { IAppearance } from '../models/interfaces';

export class Appearance implements IAppearance {
    color: string = '';
    highlight: boolean = false;
    private readonly _defaultColor: string = 'black';

    constructor() {
        this.setDefaultColor();
    }

    setDefaultColor() {
        this.color = this._defaultColor;
    }
}
